export default str => {
  if(!isNaN(str)){
    return parseInt(str);
  }

  if(str === 'true' || str === 'false'){
    return str === 'true';
  }

  return str
}



// WEBPACK FOOTER //
// ./scripts/util/strToType.js